import { useEffect, useState } from 'react';
import { displayErrorNotification } from '../../../../../../utils/displayNudosStandardNotifications';
import NudosConfirmActionModal from '../../../../../../components/NudosComponents/NudosConfirmActionModal/NudosConfirmActionModal';
import { NudosSelectButton } from '../../../../../../components/NudosComponents';
import { getOrganizationData, updateSubscription } from '../../../../../../services/bussines';
import alertMessage from '../../../../../../utils/alertMessage';
import { CLIENT_PLAN_TYPES, TClient } from '../../../../../../types/client.types';

const PlanType = ({
  organizationId,
  updateWithoutLoaders
}: {
  organizationId: string;
  updateWithoutLoaders?: () => void;
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [planType, setPlanType] = useState<TClient>(CLIENT_PLAN_TYPES.STANDARD);
  const [clientPlan, setClientPlan] = useState<TClient>(CLIENT_PLAN_TYPES.STANDARD);
  const [modalButtonIsLoading, setModalButtonIsLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleShowModal = (type: TClient) => {
    setShowModal(!showModal);
    setClientPlan(type);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  const fetchOrganizationInfo = async () => {
    if (!organizationId) return;
    setModalButtonIsLoading(true);
    setLoading(true);
    try {
      const { subscriptionsDetails } = await getOrganizationData(organizationId);
      const { levelSubscription } = subscriptionsDetails;
      setPlanType(levelSubscription === 'Free' ? CLIENT_PLAN_TYPES.STANDARD : CLIENT_PLAN_TYPES.PLATINUM);
    } catch (error) {
      displayErrorNotification();
    } finally {
      setModalButtonIsLoading(false);
      setLoading(false);
    }
  };
  const handleUpdatePlanType = async () => {
    try {
      setModalButtonIsLoading(true);
      const subscriptionId = clientPlan === CLIENT_PLAN_TYPES.STANDARD ? 1 : 2;

      await updateSubscription(+organizationId, { platformSubscriptionId: subscriptionId });
      setPlanType(clientPlan);
      alertMessage('Se actualizó la información correctamente');
    } catch (error) {
      displayErrorNotification();
    } finally {
      updateWithoutLoaders?.();
      setModalButtonIsLoading(false);
      closeModal();
    }
  };

  const modalContinueButtonText = () => {
    if (clientPlan === CLIENT_PLAN_TYPES.PLATINUM) {
      return 'Marcar como Platinum';
    }
    return 'Marcar como Standard';
  };
  const modalText = () => {
    if (clientPlan === CLIENT_PLAN_TYPES.PLATINUM) {
      return 'Al marcar como Platinum, se aplicarán descuentos en compras y servicios logísticos a este cliente, ¿estás seguro?';
    }
    return 'Al marcar como Standard, el cliente perderá descuentos en compras y servicios logísticos ¿estás seguro?';
  };

  useEffect(() => {
    fetchOrganizationInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {showModal && (
        <NudosConfirmActionModal
          firstButtonAction={closeModal}
          secondButtonAction={handleUpdatePlanType}
          firstButtonText="Cancelar"
          secondButtonText={modalContinueButtonText()}
          modalText={modalText()}
          isLoading={modalButtonIsLoading}
        />
      )}
      <div className="accountTitle">Tipo de plan</div>
      <div className="accountOptions">
        {loading ? (
          <div className="loaderOptions animationLoader" />
        ) : (
          <>
            <div className="optionAccount">
              <NudosSelectButton
                colorPalette="black"
                handleClickButton={() => handleShowModal(CLIENT_PLAN_TYPES.STANDARD)}
                isButtonActive={planType === CLIENT_PLAN_TYPES.STANDARD}
              />
              <div className="optionText">Standard</div>
            </div>
            <div className="optionAccount">
              <NudosSelectButton
                colorPalette="black"
                handleClickButton={() => handleShowModal(CLIENT_PLAN_TYPES.PLATINUM)}
                isButtonActive={planType === CLIENT_PLAN_TYPES.PLATINUM}
              />
              <div className="optionText">Platinum</div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PlanType;
